import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const CalendarCheckFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M20.28 18.54H3.72V5.38H20.28V18.54ZM18.44 9.66V7.22H5.56V9.66H18.44ZM8.58 13.28L11.24 15.96L15.3 11.88L14.34 10.92L11.24 14.04L9.54 12.34L8.58 13.28Z" />
    </SvgIcon>
  );
});
